import React from 'react'

import { Stack, useMultiStyleConfig } from '@chakra-ui/react'
import { Icon, Typography } from '@pnld/components-web'

import { ITotalizerDisplayProps } from './types'

const TotalizerDisplay = ({
  number,
  label,
  variant = 'primary',
  icon = '',
  fullWidth = false,
  small = false,
}: ITotalizerDisplayProps) => {
  const styles = useMultiStyleConfig('TotalizerDisplay', { variant })

  const abbreviateNumber = (num: number | undefined): string => {
    if (num === undefined || num === null || isNaN(num)) {
      return '0'
    }

    if (Math.abs(num) < 1000) {
      return num % 1 === 0 ? num.toString() : num.toFixed(2)
    }

    const units = [
      '',
      'mil',
      'mi',
      'bi',
      'tri',
      'qua',
      'qui',
      'sex',
      'sep',
      'oct',
      'nov',
      'dec',
    ]
    let i = 0
    let abbreviatedValue = num

    while (Math.abs(abbreviatedValue) >= 1000 && i < units.length - 1) {
      abbreviatedValue /= 1000
      i++
    }

    // Para números abreviados, usa até 2 casas decimais se necessário
    const fixedValue = parseFloat(abbreviatedValue.toFixed(2))

    return `${fixedValue} ${units[i]}`
  }

  return (
    <Stack
      __css={styles.cardBox}
      width={fullWidth ? '100%' : 'auto'}
      direction={small ? 'row' : 'column'}
      align={small ? 'center' : 'flex-start'}
      gap={small ? 4 : undefined}
    >
      {icon ? (
        <Icon {...styles.cardIcon} name={icon} />
      ) : (
        <Icon name="" {...styles.cardIcon} />
      )}
      {small ? (
        <Stack spacing={0}>
          <Typography variant="d-sm" color="brand.primary.dark_1">
            {abbreviateNumber(number)}
          </Typography>
          <Typography variant="h-2xs" color="brand.primary.dark_1">
            {label}
          </Typography>
        </Stack>
      ) : (
        <>
          <Typography variant="d-sm" color="brand.primary.dark_1">
            {abbreviateNumber(number)}
          </Typography>
          <Typography variant="h-2xs" color="brand.primary.dark_1">
            {label}
          </Typography>
        </>
      )}
    </Stack>
  )
}

export default TotalizerDisplay
